import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import CookieBanner from './components/feature/CookieBanner';

const App: React.FC = () => {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieBanner />
    </BrowserRouter>
  );
};

export default App;
